// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {}
}

const yearSettings = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_YEAR_SETTINGS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_YEAR_SETTINGS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    default:
      return { ...state }
  }
}
export default yearSettings
